package com.hyperether.goodjob.scenes.user.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.OutlinedTextField
import androidx.compose.material.Text
import androidx.compose.material.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.em
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.ic_search
import com.hyperether.goodjob.resources.jobs_list
import com.hyperether.goodjob.resources.location
import com.hyperether.goodjob.resources.search
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.this_week
import com.hyperether.goodjob.resources.time
import com.hyperether.goodjob.resources.title
import com.hyperether.goodjob.scenes.addNew.DropdownSortBy
import com.hyperether.goodjob.scenes.components.WebFilterButton
import com.hyperether.goodjob.scenes.user.UserViewModel
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun UserDailyActivities(viewModel: UserViewModel) {
    Box(
        modifier = Modifier.fillMaxWidth()
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .clip(
                    shape = RoundedCornerShape(
                        topStart = 4.toScaleDp(),
                        topEnd = 4.toScaleDp()
                    )
                )
                .background(color = Color.White)
        )
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .padding(horizontal = 23.toScaleDp())
        ) {
            Column(
                modifier = Modifier.weight(2f),
            ) {
                Text(
                    text = stringResource(Res.string.jobs_list),
                    fontSize = 24.toScaleSp(),
                    fontWeight = FontWeight.W700,
                )
            }

            OutlinedTextField(
                textStyle = TextStyle(fontSize = 12.toScaleSp()),
                value = viewModel.jobSearchText.value,
                onValueChange = { viewModel.jobSearchText.value = it },
                placeholder = {
                    Text(
                        text = stringResource(Res.string.search),
                        fontSize = 12.toScaleSp(),
                        fontWeight = FontWeight.W400
                    )
                },
                modifier = Modifier
                    .width(226.toScaleDp())
                    .height(53.toScaleDp())
                    .border(
                        width = 1.toScaleDp(),
                        color = BorderColor,
                        shape = RoundedCornerShape(8.toScaleDp())
                    ),
                singleLine = true,
                leadingIcon = {
                    Image(
                        modifier = Modifier
                            .height(24.toScaleDp())
                            .width(24.toScaleDp()),
                        painter = painterResource(Res.drawable.ic_search),
                        contentDescription = "Search"
                    )
                },
                colors = TextFieldDefaults.textFieldColors(
                    backgroundColor = Color.White,
                    focusedIndicatorColor = Color.Transparent,
                    unfocusedIndicatorColor = Color.Transparent
                )
            )
            Spacer(modifier = Modifier.width(16.toScaleDp()))
            // TODO: get options
            DisableSelection {
                DropdownSortBy(
                    shouldAppendSortBy = false,
                    items = listOf(stringResource(Res.string.this_week)),
                    selectedValue = viewModel.jobSortBy.value
                        ?: stringResource(Res.string.this_week),
                    onValueSelected = { viewModel.jobSortBy.value = it },
                    displayText = { it },
                    placeholderColor = BorderColor,
                    textColor = Color.Black,
                    modifier = Modifier.height(55.toScaleDp())
                )
            }

            Spacer(modifier = Modifier.width(16.toScaleDp()))

            WebFilterButton(
                onClick = {
                    viewModel.showFilterDialog.value = true
                }
            )
        }
    }
    Spacer(modifier = Modifier.height(30.toScaleDp()))

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(color = Color(0xfffafafa))
            .padding(horizontal = 45.toScaleDp())
            .requiredHeight(height = 38.toScaleDp()),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = stringResource(Res.string.title),
            color = Color(0xff797676),
            lineHeight = 1.5.em,
            style = TextStyle(fontSize = 14.toScaleSp()),
            modifier = Modifier.weight(0.9f)
        )
        Text(
            text = stringResource(Res.string.site),
            color = Color(0xff797676),
            lineHeight = 1.5.em,
            style = TextStyle(fontSize = 14.toScaleSp()),
            modifier = Modifier.weight(0.9f)
        )
        Text(
            text = stringResource(Res.string.location),
            color = Color(0xff797676),
            lineHeight = 1.5.em,
            style = TextStyle(fontSize = 14.toScaleSp()),
            modifier = Modifier.weight(1f)
        )
        Text(
            text = stringResource(Res.string.time),
            color = Color(0xff797676),
            lineHeight = 1.5.em,
            style = TextStyle(fontSize = 14.toScaleSp()),
            modifier = Modifier.weight(0.7f)
        )
        Text(
            text = stringResource(Res.string.status),
            color = Color(0xff797676),
            lineHeight = 1.5.em,
            style = TextStyle(fontSize = 14.toScaleSp()),
            modifier = Modifier.weight(0.7f)
        )
    }
//    JobListGroupedByDateWithCheckboxes(
//        viewModel = viewModel,
//        isJobList = true,
//        jobs = viewModel.jobList,
//        navHostController = navController,
//        searchQuery = searchQuery,
//        isAllSelected = isAllSelected.value,
//        onAllSelectedChange = { isChecked -> },
//        selectedJobs = viewModel.selectedJobs,
//        onJobSelectedChange = {}
//    )
}